import { useEffect, useState } from 'react'

import { MenuPromotionProductCard, ProductTypes } from 'modules/products'
import { SeoListName } from 'shared/analytics'
import { getRemainingPromotionTime } from 'shared/utils/date'

import styles from './CategoriesButtonMenuSinglePromotion.module.scss'

const SPECIAL_PROMOTION_ITEMS_LIST_NAME =
  SeoListName.SPECIAL_PROMOTION_ITEMS_LIST_NAME

const CategoriesButtonMenuSinglePromotion = ({
  promotedProduct
}: {
  promotedProduct: ProductTypes
}) => {
  const [remainedPromotionTime, setRemainedPromotionTime] = useState(
    getRemainingPromotionTime(promotedProduct.specialOfferEndsAt)
  )

  useEffect(() => {
    const interval = setInterval(() => {
      const updatedTime = getRemainingPromotionTime(
        promotedProduct.specialOfferEndsAt
      )

      setRemainedPromotionTime(updatedTime)
    }, 1000)

    return () => clearInterval(interval)
  }, [promotedProduct.specialOfferEndsAt])

  return (
    <div className={styles.wrapper}>
      <h3 className={styles.title}>Lokalny Rolnik poleca!</h3>
      <MenuPromotionProductCard
        product={promotedProduct}
        seoButtonPlace={promotedProduct.slug}
        productPath={promotedProduct.slug}
        listName={SPECIAL_PROMOTION_ITEMS_LIST_NAME}
        idxOnList={0}
      />
      {remainedPromotionTime && (
        <div className={styles.remainedTimeWrapper}>
          <p className={styles.remainedTimeTitle}>
            Oferta kończy się za:
          </p>
          <div className={styles.remainedTimeCounterWrapper}>
            <div className={styles.remainedTimeCounterNumberWrapper}>
              <span className={styles.remainedTimeCounterNumber}>
                {remainedPromotionTime.hours}
              </span>
              <span className={styles.remainedTimeCounterLabel}>
                godz.
              </span>
            </div>
            <span className={styles.dot}>:</span>
            <div className={styles.remainedTimeCounterNumberWrapper}>
              <span className={styles.remainedTimeCounterNumber}>
                {remainedPromotionTime.minutes}
              </span>
              <span className={styles.remainedTimeCounterLabel}>
                min.
              </span>
            </div>
            <span className={styles.dot}>:</span>
            <div className={styles.remainedTimeCounterNumberWrapper}>
              <span className={styles.remainedTimeCounterNumber}>
                {remainedPromotionTime.seconds}
              </span>
              <span className={styles.remainedTimeCounterLabel}>
                sek.
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default CategoriesButtonMenuSinglePromotion
